module.exports = __webpack_public_path__ + "img/Insurance-needs.16a71652.svg";